var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 19.6,
    viewBox: "0 0 18 19.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3438",
    "data-name": "Group 3438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3439",
    "data-name": "Group 3439",
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1867",
    "data-name": "Rectangle 1867",
    width: 16,
    height: 16,
    rx: 3.2,
    transform: "translate(1 2.6)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    y2: 3.2,
    transform: "translate(5 1)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    y2: 3.2,
    transform: "translate(13 1)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    x2: 16,
    transform: "translate(1 7.4)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3440",
    "data-name": "Group 3440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8558",
    "data-name": "Path 8558",
    d: "M13.8,14.6a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8559",
    "data-name": "Path 8559",
    d: "M13.8,11.4a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8560",
    "data-name": "Path 8560",
    d: "M9.8,14.6a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8561",
    "data-name": "Path 8561",
    d: "M9.8,11.4a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8562",
    "data-name": "Path 8562",
    d: "M5.8,14.6a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8563",
    "data-name": "Path 8563",
    d: "M5.8,11.4a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ea65a23aa96606a08d8cacafeab57864.svg";
export { ForwardRef as ReactComponent };